import { getAccessToken } from '@flowwai-frontend/shared/auth/web'
export const isLoggedIn = () => getAccessToken() !== undefined
